import { testimonials } from "@/mocks/data";

export default function Community() {
  return (
    <section id="about" className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <div className="mb-3 text-sm font-medium text-primary-600">
            <i className="ri-community-line mr-2"></i>
            瓜友口碑
          </div>
          <h2 className="font-heading text-2xl text-foreground-950 md:text-4xl">
            他们都在每日吃瓜
          </h2>
          <p className="mt-4 text-sm text-foreground-600 md:text-base">
            通勤党、综艺粉、睡前党……不同人群用吃瓜每日把追瓜理顺成日常习惯,来看看他们的评价。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
          {testimonials.map((t) => (
            <figure
              key={t.name}
              className="flex flex-col rounded-2xl bg-background-50 p-6 ring-1 ring-background-200"
            >
              <div className="flex items-center gap-1 text-accent-500">
                {[0, 1, 2, 3, 4].map((i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                “{t.text}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                <img
                  src={t.avatar}
                  alt={`${t.name}的头像`}
                  className="h-10 w-10 rounded-full object-cover"
                />
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{t.name}</div>
                  <div className="text-xs text-foreground-500">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}